import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const useMerchant = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get("/saas/member/v1/merchant");
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    merchantLoading: loading,
    merchant: data,
    fetchMerchant: fetchData
  };
};
export const useMerchantModal = createModel(useMerchant);
export const useMerchantEmail = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get("/saas/merchant/get-merchant-email");
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    merchantEmailLoading: loading,
    merchantEmail: data,
    fetchMerchantEmail: fetchData
  };
};
export const useMerchantEmailModal = createModel(useMerchantEmail);
